import { render, staticRenderFns } from "./AccountFlowShell.vue?vue&type=template&id=55603b82&scoped=true"
import script from "./AccountFlowShell.vue?vue&type=script&lang=js"
export * from "./AccountFlowShell.vue?vue&type=script&lang=js"
import style0 from "./AccountFlowShell.vue?vue&type=style&index=0&id=55603b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55603b82",
  null
  
)

export default component.exports